import { render } from "./AccommodationView.vue?vue&type=template&id=49dc22ad&scoped=true"
import script from "./AccommodationView.vue?vue&type=script&lang=js"
export * from "./AccommodationView.vue?vue&type=script&lang=js"

import "./AccommodationView.vue?vue&type=style&index=0&id=49dc22ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dc22ad"]])

export default __exports__